export function windowOpen(url: string): void {
  window.open(url, '_self');
}

export function windowOpenPopup(url: string): void {
  window.open(url, '_blank', 'width=400, height=500');
}
